<template>
  <div>
    Article {{ $route.params.articleid }}
    <pre v-text="article"></pre>
  </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import messages from "./modules/lang/main/export";

export default {
  i18n: { messages },
  components: {},
  watch: {},
  computed: {
    ...mapGetters([
      "isLoggedIn",
      "authStatus",
      "TagProfiles",
      "getTags",
      "userId",
    ]),
  },
  methods: {
    ...mapActions(["GET_PUBLIC_ARTICLE"]),
  },
  data() {
    return {
      article: {},
      SERVERADRESS: process.env.VUE_APP_BASEAPI,
      waitForServerResponse: false,
      waitForServerResponseMsg: "Please wait...",
    };
  },

  mounted() {
    this.GET_PUBLIC_ARTICLE(this.$route.params.articleid).then((resp) => {
      // console.log("-".repeat(10));
      // console.log(resp);
      // console.log("-".repeat(10));

      this.article = resp.data;
    });
  },
};
</script>